import { 
  FETCH_CHILDREN_SUCCESS,
  ADD_CHILD_SUCCESS,
  UPDATE_CHILD_SUCCESS,
  DELETE_CHILD_SUCCESS,
} from '../actions/childActions';

const initialState = {
  children: [],
};

const childReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CHILDREN_SUCCESS:
      return { ...state, children: action.payload };
case ADD_CHILD_SUCCESS:
      if (!action.payload) {
        return state;
      }
      return { ...state, children: [...state.children, action.payload] };
    case UPDATE_CHILD_SUCCESS:
      if (!action.payload || !action.payload.child_id) {
        return state;
      }
      return {
        ...state,
        children: state.children.map((child) =>
          child.child_id === action.payload.child_id ? action.payload : child
        ),
      };
    case DELETE_CHILD_SUCCESS:
      return {
        ...state,
        children: state.children.filter((child) => child.child_id !== action.payload),
      };
    default:
      return state;
  }
};

export default childReducer;
